import { Node } from "@contentful/rich-text-types";

export const renderEmbeddedEntry = (node: Node): string => {
    return `<embed type="${node.nodeType}" src="${node.data.target.sys.id}"/>`;
};
